import { createContext } from 'react'

interface AuctionCountContextProps {
  availableAuctionCount?: number
  busy?: boolean
  clearAuctionCounts?: () => void
  completedAuctionCount?: number
  dutchAuctionCount?: number
  liveAuctionCount?: number
  mintedAuctionCount?: number
  refreshAuctionCounts?: () => void
  upcomingAuctionCount?: number
}

export const AuctionCountContext = createContext<AuctionCountContextProps>({})
